'use strict';

import appConstants from 'constants/appConstants';

// CoreService error bodies are either an application message (a JSON string such as
// "Insufficient leave hours is not allowed.") or a problem object {title, status, traceId, Message}
// (pen test 2026-53 V7). Components render the stored error directly, so reduce it to a string once here;
// anything else (e.g. an unparsed text body) yields null so the status-based fallback applies.
export const errorBodyMessage = function (body) {
    if (typeof body === 'string') {
        return body;
    }

    if (body && typeof body === 'object') {
        if (typeof body.Message === 'string' && body.Message) {
            return body.Message;
        }

        if (typeof body.title === 'string' && body.title) {
            return body.title;
        }
    }

    return null;
};

// Text of a stored error for display or concatenation: processAction stores strings, except the overWriteError
// shape {Message}. Anything else yields ''.
export const errorText = function (error) {
    if (typeof error === 'string') {
        return error;
    }

    if (error && typeof error.Message === 'string') {
        return error.Message;
    }

    return '';
};

// The stored error for a failed request: the overWriteError shape, else the body's message, else a message for
// the status code.
const requestError = function (response, overWriteError) {
    if (overWriteError) {
        return {
            Message: overWriteError,
        };
    }

    let error;
    try {
        error = errorBodyMessage(response.error.response.body);
    } catch (e) {
        // No response at all (network failure, aborted request): components render the error as text.
        return appConstants.error.GENERIC_ERROR;
    }

    if (error) {
        return error;
    }

    const statusCode = response.error.response.statusCode;
    return (statusCode && appConstants.error.STATUS_CODE[statusCode]) || appConstants.error.GENERIC_ERROR;
};

const deliverSuccess = function (response, successCallback) {
    if (!successCallback) {
        return;
    }

    if (response.data.body || response.data.body === 0) {
        successCallback(response.data.body);
    } else if (response.data) {
        successCallback(response.data);
    }
};

const processAction = function (response, successCallback, overWriteError) {

    const success = false;
    let loading = false;
    let error = null;

    if (response.data === appConstants.request.PENDING) {
        loading = true;
    } else if (response.data === appConstants.request.TIMEOUT) {
        error = 'TIMEOUT';
    } else if (response.data === appConstants.request.ERROR) {
        error = requestError(response, overWriteError);
    } else {
        deliverSuccess(response, successCallback);
    }

    return {
        loading,
        success,
        error,
    };
};

export default processAction;
